import { Box } from "@mui/material";
import { Flex } from "Components/_Shared/Core/Flex";
import type { ReactNode } from "react";

export type IconBadgeColor = "grey" | "success" | "error" | "info" | "warning" | "primary";

type Props = {
  icon: ReactNode;
  color?: IconBadgeColor;
};

const colorMap: Record<IconBadgeColor, { outer: string; inner: string; icon: string }> = {
  success: { outer: "success.main", inner: "success.light", icon: "success.dark" },
  error: { outer: "error.main", inner: "error.light", icon: "error.dark" },
  warning: { outer: "warning.main", inner: "warning.light", icon: "warning.dark" },
  info: { outer: "info.main", inner: "info.light", icon: "info.main" },
  primary: { outer: "primary.main", inner: "primary.light", icon: "primary.dark" },
  grey: { outer: "grey.400", inner: "grey.100", icon: "grey.600" },
};

export const IconBadge = ({ icon, color = "grey" }: Props) => {
  const colors = colorMap[color];

  return (
    <Box
      sx={{
        width: 95,
        height: 95,
        borderRadius: "50%",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          bgcolor: colors.outer,
          opacity: 0.08,
        },
      }}
    >
      <Flex
        sx={{
          width: 65,
          height: 65,
          borderRadius: "50%",
          bgcolor: colors.inner,
          alignItems: "center",
          justifyContent: "center",
          color: colors.icon,
        }}
      >
        {icon}
      </Flex>
    </Box>
  );
};
